import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'getm-block-header',
  templateUrl: './block-header.component.html',
  styleUrls: ['./block-header.component.scss'],
})
export class BlockHeaderComponent {

  @Input() title: string = '';
  @Input() iconName: string = '';
  @Input() iconTitleColor: string = '';
  @Input() backgroundColor: string = '';
  @Input() showIconInfo: boolean = false;
  @Input() showIconArrow: boolean = false;

  @Output() infoClick = new EventEmitter<void>();
  @Output() arrowClick = new EventEmitter<void>();

  public isArrowExpanded: boolean = false;
  public arrowIconName: string = 'getm-chevron-down-outline';

  public onInfoClick(): void {
    this.infoClick.emit();
  }

  public onArrowClick(): void {
    this.isArrowExpanded = !this.isArrowExpanded;
    this.arrowIconName = this.isArrowExpanded ? 'getm-chevron-up-outline' : 'getm-chevron-down-outline';
    this.arrowClick.emit();
  }

}
